import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Header from "./Header";
import { Link } from "react-router-dom";
import AccountNav from "./AccountNav";
import { records, makeNotiRead,makeAsRead } from "../../../services/notification";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import { updateProfileData, records as userRecords } from "../../../services/userDatails";

class Notifications extends Component {
    
	state = {
		notification : true,	
		item: {},
		unread: 0,
        loading: true,
		email_notification: true
	};

	handleMenu = field => {
		if(field == 'notification')
		{
			this.setState({notification : true});
		}	
		
	}

	markallRead = () => {
        this.setState({
			unread: 0,
			loading: true
        });
        makeAsRead(this.context.state.lastNotification);
        records('all').then(response => {
			this.setState({
				items: response.data,
				unread: response.meta.unread,
				loading: false
			});
		});
    };

	markRead = id => {	
		this.setState({			
			loading: true
        });	
        makeNotiRead(id).then(response => {
			this.setState({
				items: response.data,
				unread: response.meta.unread,
				loading: false
			});
		});
    };

    componentDidMount() {
		records('all').then(response => {
			this.setState({
				items: response.data,
				unread: response.meta.unread,
				loading: false
			});
        });
        
        userRecords()
            .then(res => {
                this.setState({
                    email_notification: res.data.email_notification,
                    
                });
            })
            .catch(err => {
                this.context.state.handelError(err);
            });
    }
	
	handleCheckBoxChange = e => {
        const toggled = this.state[e.target.id] === "true" ? "false" : "true";        
        this.setState({ [e.target.id]: toggled });
    };
	
    updateEmailNotification = () => {
        setTimeout(() => {
            updateProfileData({
                key: "email_notification",
                value: this.state.email_notification
            })
                .then(res => {
                    this.context.state.showCodeMessage(
                        "Your Email Notifications status has been updated!",
                        "success"
                    );
                })
                .catch(error => {
                    this.context.state.showCodeMessage(
                        "Something went wrong!",
                        "error"
                    );
                });
        });
    };
	
	render() {
        return (
            <Fragment>
                <Header></Header>
                <div>
				    {/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Notifications</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="portfolioDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
						<div className="container writer-container">
							<div className="row justify-content-center">
								<div className="col-lg-12 col-md-12">									
								    <div className="header">
                                        <div className="header-body">
                                            <div className="row align-items-center">
                                                <div className="col-auto">
                                                    <h1 className="header-title">
                                                        Notifications
                                                    </h1>
                                                </div>
												<div className="col">
												    <div className="d-flex align-items-center m-form__group justify-content-end">
                                                        <label className="mb-0 mr-3">
                                                            Email notifications
                                                        </label>
                                                        <div className="custom-control custom-switch">
                                                            <input
                                                                onClick={
                                                                    this
                                                                        .updateEmailNotification
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleCheckBoxChange
                                                                }
                                                                checked={
                                                                    this.state
                                                                        .email_notification === 'true'
                                                                }
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                id="email_notification"
                                                            />
                                                            <label
                                                                className="custom-control-label"
                                                                htmlFor="email_notification"
                                                            ></label>
                                                        </div>
                                                    </div>
												</div>
                                            </div>
                                        </div>
                                    </div>
									<div className="card">
									    <div className="table-responsive">
                                            {this.state.loading === true ? (
                                                <LoadingData></LoadingData>
                                            ) : this.state.items.length === 0 ? (
                                                <NoData></NoData>
									    
                                            ) : (
                                                <table className="table table-sm table-nowrap card-table">
												    {/*<thead>
                                                        <tr>
                                                            <th>Notification</th>
                                                            <th className="text-right">
																{this.state.unread > 0 ? <button                                                                   
                                                                            type="button"
																			className="btn btn-primary btn-sm ml-2"
																			onClick={() => this.markallRead()}																			
                                                                        >
                                                                            Read All
                                                                        </button> : null }</th> 
                                                        </tr>
											        </thead>*/}
                                                    <tbody className="list">
                                                        {this.state.items.map((item, index) => {
                                                        	return (
                                                        		<tr key={index} className={item.status}>
                                                        			<td>
                                                        				{item.body}
                                                                        <span className="small mt-1 d-block">{item.created_at}</span>
                                                        			</td>
																	<td className="text-right align-middle">
																	    {item.status == 'unread' ? <div                                                                  
                                                                            className="m-read"
																	    	data-toggle="tooltip"
																	    	data-placement="top"
																	    	title="Mark as read"
																	    	onClick={() => this.markRead(item.id)}																			
                                                                        >
                                                                        </div> : null }
																	</td>
                                                        		</tr>
                                                        	);
                                                        })}
                                                    </tbody>
                                                </table>
									        )}
                                        </div>
                                    </div>
								</div>
							</div>
						</div>
					</section>
				</div>
            </Fragment>
        );
    }
}

Notifications.contextType = AppContext;
export default Notifications;



// WEBPACK FOOTER //
// ./src/components/writer/account/Notifications.js